/** 管理路由 */
import Layout from '@/views/layout/eventLayout'

const Router = {
	path: '/event',
	component: Layout,
	redirect: '/event/index',
	name: 'event',
	hidden: true,
	meta: {
		requiresAuth: true,
		title: '日程',
		index: 0,
		type: 'event'
	},
	children: [
		{
			path: 'index', 
			component: () => import('@/views/event/index'),
			meta: {
				requiresAuth: true,
				title: '日程',
				index: 1,
				type: 'event',
				subType: 'index'
			}
		}
  ]
}

export default Router